import React, { useEffect } from 'react';
import MainHeading from '../Common/MainHeading';
import animationFunction from '../Common/animationFunction';
import { useLocale } from '../../localization/LocaleContext';

export default function OurFeatures(){
    const { t } = useLocale();
    useEffect(() => {
        animationFunction('animation-img')
    })
    return(
        <section className="features sp-90">
                <MainHeading headingName={t('homeFeatures.heading')} />
                <div className="container sp-60">
                    <div className="row m-margin">
                        <div className="col-lg-6 flex-align-items">
                            <img src="/images/Group10.png" className="animation-img feature-img" alt="feature-img" />
                        </div>
                        <div className="col-lg-6 flex-align-items flex-column  ">
                            <h3 className="h-3 mb-25 feature-heading pl-10">{t('homeFeatures.feature1.prefix')} <span className="span-color">{t('homeFeatures.feature1.highlight')}</span> {t('homeFeatures.feature1.suffix')}</h3>
                            <p className="paragraph w-80 p-adjustment mb-25 pl-10">{t('homeFeatures.feature1.description')}</p>
                            <div className="pl-10">
                            {/* <button className="l-btn br-8 mt-10">Learn More</button> */}
                            </div>                           
                        </div>
                    </div>
                    <div className="row m-margin reverse">
                        <div className="col-lg-6 flex-align-items">
                            <img src="/images/Group11.png" className="animation-img feature-img" alt="feature-img" />
                        </div>
                        <div className="col-lg-6 flex-align-items flex-column  ">
                            <h3 className="h-3 mb-20 feature-heading">{t('homeFeatures.feature2.prefix')} <span className="span-color">{t('homeFeatures.feature2.highlight')}</span> {t('homeFeatures.feature2.suffix')}</h3>
                            <p className="paragraph w-80 p-adjustment mb-25">{t('homeFeatures.feature2.description')}</p>
                            <div className="">
                            {/* <button className="l-btn br-8 mt-10">Learn More</button> */}
                            </div>                           
                        </div>
                    </div>
                    <div className="row m-margin">
                        <div className="col-lg-6 flex-align-items">
                            <img src="/images/Group12.png" className="animation-img feature-img" alt="feature-img" />
                        </div>
                        <div className="col-lg-6 flex-align-items flex-column  ">
                            <h3 className="h-3 mb-20 pl-10 feature-heading"><span className="span-color">{t('homeFeatures.feature3.highlight')}</span> {t('homeFeatures.feature3.suffix')}</h3>
                            <p className="paragraph w-80 p-adjustment mb-20 pl-10">{t('homeFeatures.feature3.description')}</p>
                            <div className="pl-10">
                            {/* <button className="l-btn br-8 mt-10">Learn More</button> */}
                            </div>                           
                        </div>
                    </div>
                    <div className="row m-margin reverse">
                        <div className="col-lg-6 flex-align-items">
                            <img src="/images/Group14.png" className="animation-img feature-img" alt="feature-img" />
                        </div>
                        <div className="col-lg-6 flex-align-items flex-column  ">
                            <h3 className="h-3 mb-20 feature-heading"><span className="span-color">{t('homeFeatures.feature4.highlight')}</span> {t('homeFeatures.feature4.suffix')}</h3>
                            <p className="paragraph w-80 p-adjustment mb-20">{t('homeFeatures.feature4.description')}</p>
                            <div className="">
                            {/* <button className="l-btn br-8 mt-10">Learn More</button> */}
                            </div>                           
                        </div>
                    </div>
                    <div className="row m-margin">
                        <div className="col-lg-6 flex-align-items">
                            <img src="/images/Group13.png" className="animation-img feature-img" alt="feature-img" />
                        </div>
                        <div className="col-lg-6 flex-align-items flex-column  ">
                            <h3 className="h-3 mb-20 pl-10 feature-heading"><span className="span-color">{t('homeFeatures.feature5.highlight')}</span> {t('homeFeatures.feature5.suffix')}</h3>
                            <p className="paragraph mb-20 pl-10 w-80 p-adjustment">{t('homeFeatures.feature5.description')}</p>
                            <div className="pl-10">
                            {/* <button className="l-btn br-8 mt-10">Learn More</button> */}
                            </div>                           
                        </div>
                    </div>
                </div>
            </section>
    )
}